
     import Vue from 'vue';
     export default {
       scrollToTop: true,
       head() {
         return {
           title: this.title,
           meta: [{
               hid: 'og:title',
               property: 'og:title',
               content: this.title
             },
             {
               hid: 'twitter:title',
               property: 'twitter:title',
               content: this.title
             },
             {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Durge Durghat Bhari Tujvin Sansari" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Aarti "Durge Durghat Bhari Tujvin Sansari" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Durge Durghat Bhari Tujvin Sansari, Durga Aarti, Aarti for Goddess Durga, durge durgat bhari aarti marathi, durge durgat bhari lyrics in marathi, durge durgat bhari lyrics in english, durge durgat bhari aarti lyrics, durge durgat bhari lyrics'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Durge Durghat Bhari Tujvin Sansari, Durga Aarti, Aarti for Goddess Durga, Devi Aarti, Durga Bhajan, Durga Puja Aarti, devotional aarti, Goddess Durga prayers, Aarti lyrics, Durga Aarti in Marathi, Durga Maa Aarti, Navratri Aarti, दुर्गा आरती, दुर्गा जी की आरती, durge durgat bhari aarti marathi, durge durgat bhari lyrics in marathi, durge durgat bhari lyrics in english, durge durgat bhari aarti lyrics, durge durgat bhari lyrics'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/durga.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/durga.webp'
          },
           ],
         }
       },
     
       components: {
      },
      data() {
        return {
          title: 'Durge Durghat Bhari Tujvin Sansari | Durga Aarti - दुर्गे दुर्घट भारी तुजविण संसारी(देवीची आरती)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/durga"
        },
        "headline": "Durge Durghat Bhari Tujvin Sansari - दुर्गे दुर्घट भारी तुजविण संसारी(देवीची आरती)",
        "name" : "Durge Durghat Bhari Tujvin Sansari - Durga Aarti",
        "description": "Explore the full lyrics of Aarti 'Durge Durghat Bhari Tujvin Sansari' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/durga.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    }, 
  
  
      computed: {
  
      },
      methods:{
      changeLanguage:function () {
        this.langauageMarathi = !this.langauageMarathi
      }
    }
  
    }
  